import axiosInstance from "../utils/axios"
// import { handleApiError } from "../utils/errorHandler"

export const bannerService = {
    fetchAll: async (params = {}) => {
      const response = await axiosInstance.get('/banner/paginate', {
        params,
      })
      return response.data
    },
    getById: async (id) => {
      const response = await axiosInstance.get('/banner/' + id)
      return response.data
    },
    store: async (data) => {
      const response = await axiosInstance.postForm('/banner', data )
      return response.data
    },
    update: async (data) => {
      const response = await axiosInstance.putForm(`/banner/${data.id}`, data)
      return response.data
    },
    delete: async (id) => {
      const response = await axiosInstance.delete(`/banner/${id}`)
      return response.data
    },
}